import { EnquiryService } from '@/app/services/enquiry'
import { ErrorResponse, IApiIndividualResponse } from '@/types/api'
import { IEnquiry, IEnquiryCreatePayload } from '@/types/enquiry'
import { useMutation, useQueryClient } from 'react-query'

export function useEnquiryMutation() {
  const queryClient = useQueryClient()

  return useMutation<
    IApiIndividualResponse<IEnquiry>,
    ErrorResponse,
    IEnquiryCreatePayload
  >(EnquiryService.RESOURCE_PATH, EnquiryService.postEnquiry, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(EnquiryService.RESOURCE_PATH)
    },
  })
}
